import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { ListWrapper } from './ListWrapper'

const productBreadcrumbs: Array<PageLink> = [
  {
    title: 'Admin',
    path: '/admin/products',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ProductPage = () => {
  return (
    <>
      <PageTitle breadcrumbs={productBreadcrumbs}>Lista de Produtos</PageTitle>
      <ListWrapper />
    </>
  )
}

export default ProductPage
